import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  useTheme,
  CircularProgress
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ArthaContinueButton from '../../fields/ArthaContinueButton';

const SessionExpiredModal = ({ open, onClose }) => {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);

  const handleRedirect = () => {
    setIsLoading(true);
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      disableEscapeKeyDown
      onBackdropClick={(e) => e.stopPropagation()}
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: '320px'
        }
      }}
    >
      <DialogTitle 
        sx={{ 
          textAlign: 'center',
          pb: 1
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
          <WarningAmberIcon sx={{ color: theme.palette.warning.main }} />
          <Typography variant="h6" component="span">
            Session Expired
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pb: 2 }}>
        <Typography 
          align="center"
          color="text.secondary"
          sx={{ px: 2 }}
        >
          Your session has expired. Please log in again to continue.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, justifyContent: 'center' }}>
        <ArthaContinueButton 
          onClick={handleRedirect}
          variant="contained"
          size="large"
          disabled={isLoading}
          sx={{
            minWidth: '120px',
            borderRadius: theme.shape.borderRadius,
          }}
        >
          {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Log In'}
        </ArthaContinueButton>
      </DialogActions>
    </Dialog>
  );
};

SessionExpiredModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default SessionExpiredModal;
